// Mock data for iGreen Energy Franquias clone

export const stats = [
  { icon: 'Users', value: '+400 mil', label: 'Clientes ativos' },
  { icon: 'TrendingUp', value: 'Até 4%', label: 'Comissão recorrente' },
  { icon: 'Zap', value: '+500', label: 'Usinas solares' },
  { icon: 'Award', value: 'GPTW', label: 'Certificada' },
];

export const partners = [
  { name: 'Vibra Energia', detail: '50% de participação' },
  { name: 'CEMIG', detail: 'Parceria' },
  { name: 'COPEL', detail: 'Parceria' },
  { name: 'ENERGISA', detail: 'Parceria' },
  { name: 'ENEL', detail: 'Parceria' },
];

export const cases = [
  {
    level: 'Executivo',
    color: 'from-emerald-500/20 to-cyan-500/10',
    borderColor: 'border-emerald-500/30',
    accent: 'text-emerald-400',
    total: 'R$ 60.314,59',
    kwh: '531.407 kWh',
    isTop: false,
    displayName: 'Executivo',
    saldo: 'R$ 6.835,14',
    previa: 'R$ 6.986,00',
    holder: '500.000 kWh',
  },
  {
    level: 'Diretor',
    color: 'from-emerald-500/25 to-teal-500/10',
    borderColor: 'border-emerald-400/40',
    accent: 'text-emerald-300',
    total: 'R$ 372.397,00',
    kwh: '1.580.449 kWh',
    isTop: false,
    displayName: 'Diretor',
    saldo: 'R$ 8.019,04',
    previa: 'R$ 23.020,00',
    holder: '1.000.000 kWh',
  },
  {
    level: 'Acionista',
    color: 'from-amber-500/25 to-yellow-500/10',
    borderColor: 'border-amber-400/40',
    accent: 'text-amber-400',
    total: 'R$ 2.341.425,99',
    kwh: '7.135.702 kWh',
    isTop: true,
    displayName: 'Acionista',
    saldo: 'R$ 12.027,57',
    previa: 'R$ 130.979,00',
    holder: '7.135.702 kWh',
  },
];

export const opportunities = [
  {
    icon: 'TrendingUp',
    title: 'Mercado em Expansão',
    text: 'O mercado livre de energia cresceu 50% nos últimos 12 meses. Mais de 72 mil novos consumidores podem entrar em 2024.',
  },
  {
    icon: 'ShieldCheck',
    title: 'Empresa Sólida',
    text: 'Fundada em 2021, certificada GPTW, com mais de 400 mil clientes e parceria estratégica com a Vibra Energia.',
  },
  {
    icon: 'Coins',
    title: 'Ganhos Recorrentes',
    text: 'Ganhe comissões mensais de até 4% sobre a fatura de cada cliente que você indicar. O cliente paga a energia, você recebe.',
  },
  {
    icon: 'MapPin',
    title: 'Atuação Nacional',
    text: 'Presente em todas as regiões do Brasil com parcerias com as principais distribuidoras de energia.',
  },
];

export const products = [
  { icon: 'Leaf', title: 'Conexão Green', text: 'Economia na conta de luz sem investimento para residências e pequenas empresas.', tag: 'Até 10% de desconto' },
  { icon: 'Zap', title: 'Conexão Livre', text: 'Migração para o mercado livre de energia para empresas em alta tensão.', tag: 'Até 30% de economia' },
  { icon: 'Sun', title: 'Conexão Solar', text: 'Instalação de painéis solares sem investimento inicial do cliente.', tag: 'Bônus de 50% da 1ª fatura' },
  { icon: 'PanelsTopLeft', title: 'Conexão Placas', text: 'Projeto completo de energia solar com instalação profissional.', tag: 'Até 10% de comissão' },
  { icon: 'Signal', title: 'Conexão Telecom', text: 'Planos de telefonia e internet com a maior cobertura 5G do Brasil.', tag: 'Até R$7/mês recorrente' },
  { icon: 'Gift', title: 'Conexão Club', text: 'Clube de benefícios com mais de 600 mil produtos e serviços.', tag: 'Grátis para clientes' },
];

export const earnings = [
  { value: '10%', title: 'Bônus Imediato', desc: 'Sobre a conta líquida de cada novo cliente Conexão Livre' },
  { value: 'Até 4%', title: 'Comissão Recorrente', desc: 'Sobre a fatura iGreen de todos os seus clientes, todo mês' },
  { value: 'Até 2%', title: 'Royalties de Rede', desc: 'Sobre os ganhos da sua equipe conforme sua qualificação' },
  { value: 'R$300+', title: 'Bônus Expansão', desc: 'Por cada novo licenciado que você indicar' },
];

export const careers = [
  { name: 'Sênior', meta: '10.000 kWh', comissao: '4,2%', telecom: 'R$ 8,00/mês', bonus: 'R$ 370,00', premio: null },
  { name: 'Gestor', meta: '50.000 kWh', comissao: '4,4%', telecom: 'R$ 9,00/mês', bonus: 'R$ 430,00', premio: 'Experience Event – Visita à sede e usinas + treinamento com Thiago Alexander' },
  { name: 'Executivo', meta: '150.000 kWh', comissao: '4,8%', telecom: 'R$ 10,00/mês', bonus: 'R$ 490,00', premio: 'Cruzeiro pago pela empresa com acompanhante' },
  { name: 'Diretor', meta: '500.000 kWh', comissao: '5,2%', telecom: 'R$ 11,00/mês', bonus: 'R$ 550,00', premio: 'Resort no Caribe – todas as despesas pagas + acompanhante' },
  { name: 'Acionista', meta: '1.000.000 kWh', comissao: '5,5%', telecom: 'R$ 12,00/mês', bonus: 'R$ 600,00', premio: 'Viagem a Dubai – todas as despesas pagas + acompanhante + participação nos lucros mensais da empresa' },
];

export const licenseBenefits = [
  'Acesso a todas as Conexões (Green, Livre, Solar, Placas, Telecom, Club, Expansão)',
  'Treinamentos completos na iGreen Academy',
  'Suporte dedicado ao licenciado',
  'Material de apoio complementar',
  'Benefícios exclusivos iGreen Club',
  'Kit completo com folder, crachá, cordão e chips',
  'eSIM ilimitado e adesivos personalizados',
  'Assistente virtual SOL para suporte',
];

export const faqs = [
  { q: 'Preciso ter experiência com vendas ou energia para ser licenciado?', a: 'Não! A iGreen oferece treinamentos completos na iGreen Academy. Você terá acesso a todo material necessário para desenvolver suas habilidades desde o zero, além do suporte direto do seu executivo Rodney Espindola.' },
  { q: 'Como funciona a comissão recorrente?', a: 'Você recebe uma comissão mensal de até 4% sobre a fatura de cada cliente que você indicar, enquanto ele permanecer ativo. É uma renda passiva que cresce à medida que sua base de clientes aumenta.' },
  { q: 'Quanto tempo leva para começar a ganhar?', a: 'Assim que sua licença é ativada, você já pode indicar clientes e começar a gerar comissões. Muitos licenciados fecham os primeiros contratos na primeira semana.' },
  { q: 'A iGreen atua em todo o Brasil?', a: 'Sim! A iGreen possui parcerias com as principais distribuidoras nacionais (CEMIG, COPEL, ENERGISA, ENEL) e atende todos os estados brasileiros.' },
  { q: 'Quanto custa a licença e como funciona a renovação?', a: 'A licença anual custa R$ 1.997 (ou 12x de R$ 197,41). A renovação anual é de R$ 1.197, garantindo continuidade de todos os benefícios e comissões vitalícias.' },
  { q: 'Qual o suporte que receberei como licenciado?', a: 'Você contará com o suporte direto do executivo Rodney Espindola, acesso à iGreen Academy, material de apoio, assistente virtual SOL e uma comunidade ativa de licenciados.' },
];

export const heroImage = 'https://images.pexels.com/photos/12606669/pexels-photo-12606669.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940';
export const rafaelImage = 'https://customer-assets.emergentagent.com/job_renewable-energy-br/artifacts/jza1vn28_fed21f85-c10c-4a2c-a4e3-b23fcb33f974.jpeg';
export const executiveName = 'Rodney Espindola';
export const executiveRole = 'Gestor';
export const instagramUrl = 'https://instagram.com/igreenenergy.rodney';
export const executivePhone = '5547999641269';
export const executiveEmail = 'rodneybe@icloud.com';
export const executivePhoneDisplay = '(47) 99964-1269';
export const whatsappUrl = 'https://wa.me/5547999641269?text=Ol%C3%A1%20Rodney%2C%20cheguei%20at%C3%A9%20voc%C3%AA%20pelo%20site!';
